import type { PizzaModelId } from '@/lib/types';

export const PIZZA_DAY_DATE = '2010-05-22';
export const PIZZA_USD_BASELINE = 20;
export const BTC_PIZZA_DAY_TOTAL_BTC = 10000;
export const BTC_PER_PIZZA_ON_PIZZA_DAY = 5000;

export const COMPANY_DETAILS = {
  name: 'Fabrykakoparek.pl Sp. z o.o.',
  addressLine: 'ul. Świętokrzyska 30 lok. 63',
  cityLine: '00-116 Warszawa, woj. mazowieckie, Poland',
  nip: '5252738676',
  regon: '36945149000000',
  krs: '0000717863',
  email: 'singly@singly.live',
};

export const YEARLY_PIZZA_PRICE_USD: Record<number, number> = {
  2010: 20.5,
  2011: 20.81,
  2012: 21.53,
  2013: 21.94,
  2014: 22.35,
  2015: 22.45,
  2016: 22.76,
  2017: 23.27,
  2018: 23.78,
  2019: 24.19,
  2020: 24.5,
  2021: 25.63,
  2022: 27.68,
  2023: 28.8,
  2024: 29.62,
  2025: 30.34,
  2026: 31.06,
};

export const PIZZA_MODEL_LABELS: Record<PizzaModelId, string> = {
  constant_20_usd: 'Laszlo baseline ($20 per pizza)',
  yearly_schedule_usd: 'Yearly schedule (inflation-adjusted)',
};

export const DEFAULT_METRIC = 'pizzas_per_btc';
export const DEFAULT_SCALE = 'linear';
